/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClassifierRequest
 */
export interface CreateClassifierRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClassifierRequest
     */
    classifierType: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateClassifierRequest
     */
    classifierParams: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateClassifierRequest interface.
 */
export function instanceOfCreateClassifierRequest(value: object): value is CreateClassifierRequest {
    if (!('classifierType' in value) || value['classifierType'] === undefined) return false;
    if (!('classifierParams' in value) || value['classifierParams'] === undefined) return false;
    return true;
}

export function CreateClassifierRequestFromJSON(json: any): CreateClassifierRequest {
    return CreateClassifierRequestFromJSONTyped(json, false);
}

export function CreateClassifierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClassifierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classifierType': json['classifier_type'],
        'classifierParams': json['classifier_params'],
    };
}

export function CreateClassifierRequestToJSON(json: any): CreateClassifierRequest {
    return CreateClassifierRequestToJSONTyped(json, false);
}

export function CreateClassifierRequestToJSONTyped(value?: CreateClassifierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classifier_type': value['classifierType'],
        'classifier_params': value['classifierParams'],
    };
}

